/* PURE LAB — search drawer backed by Shopify predictive search.
   Results are rendered by sections/predictive-search.liquid, so the cards match the
   rest of the store instead of being rebuilt in JavaScript. */
(function () {
  var drawer = document.getElementById('search-drawer');
  if (!drawer) return;

  var form = drawer.querySelector('[data-search-form]');
  var input = drawer.querySelector('#search-drawer-input');
  var idleBlocks = drawer.querySelectorAll('[data-search-suggestions], [data-search-bestsellers-block]');
  var output = drawer.querySelector('[data-search-output]');
  if (!form || !input || !output) return;

  var predictiveUrl =
    (window.themeVariables && window.themeVariables.settings.routes.predictiveSearch) || '/search/suggest';

  var controller = null;
  var timer = null;

  function toggleIdle(visible) {
    idleBlocks.forEach(function (block) {
      block.hidden = !visible;
    });
  }

  function showIdle() {
    toggleIdle(true);
    output.hidden = true;
    output.innerHTML = '';
  }

  function render(html) {
    output.innerHTML = html;
    output.hidden = false;
    /* With results on screen the suggestions and bestsellers step aside. */
    toggleIdle(false);
  }

  function search(term) {
    if (controller) controller.abort();
    controller = new AbortController();

    var url =
      predictiveUrl +
      '?q=' +
      encodeURIComponent(term) +
      '&section_id=predictive-search' +
      '&resources[type]=product,collection' +
      '&resources[limit]=10';

    fetch(url, { signal: controller.signal })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        // The endpoint answers with a full section wrapper; take its inner markup.
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var section = parsed.querySelector('.shopify-section') || parsed.body;
        render(section.innerHTML);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') showIdle();
      });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(timer);

    if (term.length < 2) {
      showIdle();
      return;
    }

    timer = setTimeout(function () {
      search(term);
    }, 200);
  });

  form.addEventListener('submit', function (event) {
    if (input.value.trim().length === 0) event.preventDefault();
  });

  /* Popular search chips fill the field and run the query. */
  drawer.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-search-term]');
    if (chip) {
      input.value = chip.dataset.searchTerm;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
      return;
    }

    var tab = event.target.closest('[data-search-tab]');
    if (!tab) return;

    var name = tab.dataset.searchTab;
    output.querySelectorAll('[data-search-tab]').forEach(function (node) {
      node.setAttribute('aria-selected', String(node === tab));
    });
    output.querySelectorAll('[data-search-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.searchPanel !== name;
    });
  });

  /* Focus the field whenever the drawer opens. */
  drawer.addEventListener('dialog:after-show', function () {
    input.focus();
  });
})();
